export default __webpack_public_path__ + "static/media/facebook-footer.5a5d3973.svg";